// extracted by mini-css-extract-plugin
module.exports = {"form":"DownloadBonusFbModal__form--2A25G","notes":"DownloadBonusFbModal__notes--2Wr2Z"};